import React from 'react';

interface ErrorFallbackProps {
    error: any; // Sentry passes unknown/any
    resetError: () => void;
    eventId?: string;
    componentStack?: string;
}

function ErrorFallback({ error, resetError, eventId }: ErrorFallbackProps): JSX.Element {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                    Bir şeyler ters gitti
                </h2>

                <p className="text-gray-600 mb-6">
                    Beklenmedik bir hata oluştu. Hata raporu otomatik olarak iletildi.
                </p>

                {eventId && (
                    <p className="text-xs text-gray-400 mb-4 bg-gray-100 p-2 rounded">
                        Hata Referans No: {eventId}
                    </p>
                )}

                <div className="space-y-3">
                    <button
                        onClick={resetError}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                    >
                        Tekrar Dene
                    </button>

                    <button
                        onClick={() => window.location.href = '/'}
                        className="w-full bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-2 px-4 rounded-lg transition-colors"
                    >
                        Ana Sayfaya Dön
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorFallback;
